package com.exura.components.layouts.nav

import androidx.compose.runtime.Composable
import com.exura.components.icons.UntiledIcon
import com.exura.ui.Assets
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.style.toModifier

@Composable
internal fun NavigationScope.SidebarCollapseTrigger(
    onToggle: () -> Unit
) {
    Box(
        modifier = NavNavigableElementStyle.toModifier()
            .onClick { onToggle() }
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth(),
            horizontalArrangement = if (isNavigationCollapsed) Arrangement.Center else Arrangement.End
        ) {
            if (isNavigationCollapsed)
                UntiledIcon(Assets.IconsUntiled.NAV_EXPAND)
            else
                UntiledIcon(Assets.IconsUntiled.NAV_COLLAPSE)
        }
    }
}
